import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";

import MainPage from "./Pages/MainPage";
import PlayGround from "./Pages/Math/MathPlayGround";
import MathMainPage from "./Pages/Math/MathMainPage";
import UserProfile from "./Pages/UserProfile";
import WriteChinese from "./Pages/Chinese/LearnMutipleChars";
import Header from "./Header/Header";
import localeMessages from "./../locale/localeMessages";
import "./App.css";

const App =(props) => {
  return (
    <div>
      <IntlProvider messages={localeMessages[props.locale]} locale={props.locale} defaultLocale="en">
        <BrowserRouter>
            <Header />
            <Route path="/" exact component={MainPage} />
            <Route path="/maths/" exact component={MathMainPage} />
            <Route path="/maths/:testid" exact component={PlayGround} />
            <Route path="/chinese/:id" exact component={WriteChinese} />
            <Route path="/user" exact component={UserProfile} />
        </BrowserRouter>
      </IntlProvider>
    </div>
  );
}

const mapToState = (state) => {
  return {
    locale: state.userSettings.language
  };
}

export default connect(mapToState)(App);